import { ActionDice, ExtraDice, HandTypeValue } from "../rolls/Roll";
import { CommunalDice } from "./Adventure";

type AdventureEventBase = {
    id: string;
    adventureId: string;
    occurred: string;
}

export type CommunalDiceRolledAdventureEvent = {
    type: 'CommunalDiceRolledAdventureEvent';
    communalDice: CommunalDice;
} & AdventureEventBase;

export type CommunalDiceSetAdventureEvent = {
    type: 'CommunalDiceSetAdventureEvent';
    communalDice: CommunalDice;
} & AdventureEventBase;

export type PlayerJoinedAdventureEvent = {
    type: 'PlayerJoinedAdventureEvent';
    playerId: string;
} & AdventureEventBase;

export type PlayerLeftAdventureEvent = {
    type: 'PlayerLeftAdventureEvent';
    playerId: string;
} & AdventureEventBase;

export type CharacterAddedAdventureEvent = {
    type: 'CharacterAddedAdventureEvent';
    playerId: string;
    characterId: string;
} & AdventureEventBase;

export type CharacterRemovedAdventureEvent = {
    type: 'CharacterRemovedAdventureEvent';
    playerId: string;
    characterId: string;
} & AdventureEventBase;

export type PlayerRolledAdventureEvent = {
    type: 'PlayerRolledAdventureEvent';
    playerId: string;
    characterId: string;
    actionDice: ActionDice;
    extraDice: ExtraDice;
} & AdventureEventBase;

export type PlayerDeclaredHandAdventureEvent = {
    type: 'PlayerDeclaredHandAdventureEvent';
    playerId: string;
    characterId: string;
    handTypeValue: HandTypeValue;
} & AdventureEventBase;

export type AdventureEvent = CommunalDiceRolledAdventureEvent
    | CommunalDiceSetAdventureEvent
    | PlayerJoinedAdventureEvent
    | PlayerLeftAdventureEvent
    | CharacterAddedAdventureEvent
    | CharacterRemovedAdventureEvent
    | PlayerRolledAdventureEvent
    | PlayerDeclaredHandAdventureEvent;

const isRollEvent = (event: AdventureEvent): boolean => {
    return event.type == 'CommunalDiceRolledAdventureEvent'
        || event.type == 'PlayerRolledAdventureEvent';
}

export const ADVENTURE_EVENT_HELPERS = Object.freeze({
    isRollEvent
})